// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fks3","placeholdersHeader":"styles_placeholdersHeader__d1wvr","editorStyle":"styles_editorStyle__jePuZ","placeholdersBox":"styles_placeholdersBox__3DNSg"};